module.exports = __webpack_public_path__ + "img/horizontal_3_5_pp3_3016.0c84a7bd.png";